// extracted by mini-css-extract-plugin
export var button = "_ib-2";
export var card = "_ib-0";
export var closeButtonContainer = "_ib-3";
export var iconContainer = "_ib-1";